.gallery-container {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  background-color: #fff;
}

.gallery-zoom-control {
  position: absolute;
  top: 5px;
  left: 5px;
}

.gallery-control {
  position: absolute;
  cursor: pointer;
  display: none;
  top: calc(50% - 20px);
  width: 40px;
  height: 40px;
  border-right: 5px solid #000;
  border-bottom: 5px solid #000;
  border-radius: 2px;
  text-indent: -9999px;
}
@media (min-width: 768px) {
  .gallery-control {
    display: block;
  }
}
.gallery-control:hover, .gallery-control:focus {
  border-color: var(--brand-primary, #FF6600);
}
.gallery-control:focus {
  outline: none;
}
.gallery-control.left {
  transform: rotate(135deg);
  left: 25px;
}
.gallery-control.right {
  transform: rotate(-45deg);
  right: 25px;
}

uvex-gallery-image {
  display: none;
  height: calc(100vh - 80px);
  width: 100vw;
  position: relative;
  text-align: center;
  cursor: default;
  overflow: hidden;
}
uvex-gallery-image.active {
  display: inline-block;
}
uvex-gallery-image img.img-fluid {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  display: block;
  max-width: 100%;
  max-height: 100%;
  height: auto;
  width: auto;
}

.gallery-thumbnails-container {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100vw;
  overflow-y: scroll;
  background-color: #fff;
  text-align: center;
}
@media (min-width: 768px) {
  .gallery-thumbnails-container {
    height: auto;
  }
}

.gallery-thumbnails {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
}

.gallery-thumbnail {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  width: 70px;
  height: 70px;
  opacity: 0.75;
  border: 1px solid transparent;
}
.gallery-thumbnail + .gallery-thumbnail {
  margin-left: 0.25rem;
}
.gallery-thumbnail:hover, .gallery-thumbnail.active {
  opacity: 1;
  border-color: var(--brand-primary, #FF6600);
}

.gallery-thumbnail-image {
  display: inline;
  vertical-align: middle;
  max-width: 100%;
  max-height: 100%;
  height: auto;
}